export default class SystemDefault {
  static SEARCH_MODE = 3;
  static SEARCH_PAGE = 1;
  static SEARCH_RECORD = 10;

  static PAGE_SIZE = [5, 10, 20, 50, 100];

  static DEFAULT_ERROR_MESSAGE = "Field cannot be blank";
}
